import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  recharge: null,
  rechargeWelcomeOffer: null
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/recharge/index.js